import React from 'react';

const ACTUAL_COLOR   = '#6938EF';
const FORECAST_COLOR = '#DC6803';
const CAPACITY_COLOR = '#A4A7AE';

const SalesChartLegend = () => (
  <span className="mi-sales-legend">
    <span className="mi-sales-legend-item">
      <span className="mi-sales-legend-swatch" style={{ background: ACTUAL_COLOR }} />
      Actual sales
    </span>
    <span className="mi-sales-legend-item">
      <span className="mi-sales-legend-swatch mi-sales-legend-swatch-dashed" style={{ borderColor: FORECAST_COLOR }} />
      Forecast
    </span>
    <span className="mi-sales-legend-item">
      <span className="mi-sales-legend-swatch mi-sales-legend-swatch-dashed" style={{ borderColor: CAPACITY_COLOR }} />
      Capacity
    </span>
  </span>
);

export default SalesChartLegend;
